var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-link",attrs:{"type":"button"},on:{"click":_vm.act}},[_c('i',{staticClass:"icon-pencil"})])])}
var staticRenderFns = []

export { render, staticRenderFns }